import { graphql } from 'gatsby';
import QuestionPage from '../../../../../site/src/@elegantstack/gatsby-theme-flexiblog-education/containers/Question';

export default QuestionPage;

export const pageQuery = graphql`
  query QuestionPageQuery(
    $id: String!
    $previousId: String
    $nextId: String
    $categoryId: String
    $blocksPaths: [String]!
  ) {
    site {
      siteMetadata {
        locale
        siteUrl
        app {
          baseUrl
        }
      }
    }
    question: question(id: { eq: $id }) {
      ...QuestionPreview
    }
    allBlockContent: allBlockContent(
      filter: {
        page: { in: $blocksPaths }
        identifier: { in: ["header", "footer"] }
      }
    ) {
      nodes {
        ...BlockContent
      }
    }

    # Related posts based on category only
    categoryQuestions: allQuestion(
      filter: {
        private: { ne: true }
        draft: { ne: true }
        category: { id: { eq: $categoryId } }
        id: { ne: $id }
      }
      sort: { fields: [date], order: DESC }
      limit: 6
    ) {
      nodes {
        ...QuestionPreview
      }
    }

    previous: question(id: { eq: $previousId }) {
      id
      slug
      title
    }

    next: question(id: { eq: $nextId }) {
      id
      slug
      title
    }
  }
`;
